module.exports = __webpack_public_path__ + "static/media/spine-image3.febe9e68.png";